import { css } from "lit";

export const actionBarStyles = css`
    .action-bar{
        display:flex;
        align-items: center;
        gap:1em;
      }

      /*
      replaced by selector below
      .push-right {
        margin-left: auto;
      }*/

      :nth-child(1 of .action-bar > .push-right){
        margin-left: auto;
      }

      .grow{
        flex-grow:1;
      }

`